import { render, staticRenderFns } from "./callbackpay3.vue?vue&type=template&id=2fb5427e"
import script from "./callbackpay3.vue?vue&type=script&lang=js"
export * from "./callbackpay3.vue?vue&type=script&lang=js"
import style0 from "./callbackpay3.vue?vue&type=style&index=0&id=2fb5427e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports